import { useCallback } from 'react';

import { SelectionHeaderProps, StatesType } from '../types';
import SelectAll from './SelectAll';
import SelectedItems from './SelectedItems';

const SelectionHeader = ({
  selectedOptions,
  listVariant,
  initialSelectedOptions,
  filterOptions,
  methods,
  itemRenderer,
}: SelectionHeaderProps) => {
  const { toggleOption, addMultiple, removeAll } = methods;
  const isMultiUnGroupedFinite = listVariant === 'multi-ungrouped-finite';
  const selectState =
    selectedOptions.length === filterOptions.length
      ? 'all'
      : selectedOptions.length
      ? 'some'
      : 'none';

  const onSelectAllClick = useCallback(
    (nextState: StatesType) => {
      if (nextState === 'all') {
        addMultiple(filterOptions);
      } else if (nextState === 'none') {
        removeAll();
      }
    },
    [addMultiple, filterOptions, removeAll],
  );

  if (isMultiUnGroupedFinite) {
    return <SelectAll state={selectState} onSelectAllClick={onSelectAllClick} />;
  }

  const selectedItemsExist = initialSelectedOptions?.length && initialSelectedOptions?.length > 0;
  const isInfiniteList =
    listVariant === 'multi-grouped-infinite' || listVariant === 'multi-ungrouped-infinite';
  const showSelectedItems = selectedItemsExist && isInfiniteList;

  if (showSelectedItems) {
    return (
      <SelectedItems
        initialSelectedOptions={initialSelectedOptions}
        itemRenderer={itemRenderer}
        selectedOptions={selectedOptions}
        toggleOption={toggleOption}
      />
    );
  }

  return null;
};

export default SelectionHeader;
